/** Central route paths — use these instead of string literals. */

const PATIENTS_HUB = '/patients-hub';

export const paths = {
  root: '/',
  login: '/login',
  signup: '/signup',
  verifyEmail: '/verify-email',
  portalActivate: '/portal/activate',
  dashboard: '/dashboard',
  onboarding: '/onboarding',
  onboardingIdentity: '/onboarding/organisation-identity',
  onboardingServiceSites: '/onboarding/service-sites',
  onboardingYourTeam: '/onboarding/your-team',
  onboardingFirstIntake: '/onboarding/first-intake',
  onboardingComplete: '/onboarding/complete',
  participantHub: PATIENTS_HUB,
  /** Guardian portal home (participant overview). */
  guardianDashboard: '/guardian/dashboard',
  guardianParticipantProfile: (id: string) =>
    `/guardian/participant/${encodeURIComponent(id)}`,
  guardianParticipantProfileRoute: '/guardian/participant/:patientId',
  patientsArchived: `${PATIENTS_HUB}/archived`,
  patientsImportReview: `${PATIENTS_HUB}/import-review`,
  patientsNewIntake: `${PATIENTS_HUB}/new-intake`,
  patientCarePlanDraft: (patientId: string, carePlanId: string) =>
    `${PATIENTS_HUB}/patient/${encodeURIComponent(patientId)}/care-plan/${encodeURIComponent(carePlanId)}`,
  /** React Router pattern for {@link paths.patientCarePlanDraft}. */
  patientCarePlanDraftRoute: `${PATIENTS_HUB}/patient/:patientId/care-plan/:carePlanId`,
  patientProfile: (id: string) => `${PATIENTS_HUB}/patient/${encodeURIComponent(id)}`,
  /** React Router pattern for {@link paths.patientProfile}. */
  patientProfileRoute: `${PATIENTS_HUB}/patient/:patientId`,
  trainingHub: '/training-hub',
  /** Create training program wizard (4 steps). */
  trainingHubNew: '/training-hub/new',
  trainingHubEdit: (programId: string) =>
    `/training-hub/${encodeURIComponent(programId)}/edit`,
  trainingHubEditRoute: '/training-hub/:programId/edit',
  trainingHubPreview: (programId: string) =>
    `/training-hub/${encodeURIComponent(programId)}/preview`,
  trainingHubPreviewRoute: '/training-hub/:programId/preview',
  trainingHubDetail: (programId: string) =>
    `/training-hub/${encodeURIComponent(programId)}`,
  trainingHubDetailRoute: '/training-hub/:programId',
  workforce: '/workforce',
  workforceNewStaff: '/workforce/new-staff',
  workforceNewCareTeam: '/workforce/new-care-team',
  workforceStaffProfile: (staffId: string) => `/workforce/staff/${encodeURIComponent(staffId)}`,
  /** React Router pattern for {@link paths.workforceStaffProfile}. */
  workforceStaffProfileRoute: '/workforce/staff/:staffId',
  /** Former top-level URL; router redirects to {@link paths.organisationSettingsServiceSites}. */
  legacyOrganisationServiceSitesPath: '/organisation/service-sites',
  organisationSettings: '/organisation/settings',
  organisationSettingsServiceSites: '/organisation/settings/service-sites',
  organisationSettingsProfile: '/organisation/settings/organisation-profile',
  organisationSettingsBranding: '/organisation/settings/branding',
  rosterLogistics: '/roster-logistics',
  incidentManagement: '/incident-management',
  incidentManagementNew: '/incident-management/new',
  incidentManagementEdit: (incidentId: string) =>
    `/incident-management/${encodeURIComponent(incidentId)}/edit`,
  incidentManagementEditRoute: '/incident-management/:incidentId/edit',
} as const;

/** Query param on `paths.login` after successful signup (value `1`). */
export const pathQuery = {
  registered: 'registered',
  /** `guardian` or `workforce` after portal password activation. */
  portalActivated: 'portal_activated',
} as const;

export function pathLoginAfterRegister(): string {
  return `${paths.login}?${pathQuery.registered}=1`;
}

export function pathLoginAfterPortalActivate(kind: 'guardian' | 'workforce'): string {
  return `${paths.login}?${pathQuery.portalActivated}=${kind}`;
}
